"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.homeCharacterContent = void 0;
const languageUtils_1 = require("../languageUtils");
const reclaimers_red_png_1 = __importDefault(require("../../img/home/reclaimers_red.png"));
const reclaimers_color_png_1 = __importDefault(require("../../img/home/reclaimers_color.png"));
const neun_red_png_1 = __importDefault(require("../../img/home/neun_red.png"));
const neun_color_png_1 = __importDefault(require("../../img/home/neun_color.png"));
const nova_red_png_1 = __importDefault(require("../../img/home/nova_red.png"));
const nova_color_png_1 = __importDefault(require("../../img/home/nova_color.png"));
// type GroupKey = 'reclaimers' | 'neun';
// type ImageMap = Record<GroupKey, ImageVariant>;
// NOTE: Record<keys, values>
const homeWorld = {
    en: {
        title: 'Characters',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    ca: {
        title: 'Characters',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    au: {
        title: 'Characters',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    nz: {
        title: 'Characters',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    uk: {
        title: 'Characters',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    fr: {
        title: 'PERSONNAGES',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    de: {
        title: 'CHARAKTERE',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    es: {
        title: 'PERSONAJES',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    it: {
        title: 'PERSONAGGI',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    pt: {
        title: 'PERSONAGENS',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
    nl: {
        title: 'PERSONAGES',
        reclaimer: 'reclaimers',
        nova: 'nova',
        neun: 'neun',
    },
};
class homeCharacterContent {
    constructor() {
        this.imageMap = {
            reclaimers: {
                red: reclaimers_red_png_1.default,
                color: reclaimers_color_png_1.default,
            },
            neun: {
                red: neun_red_png_1.default,
                color: neun_color_png_1.default,
            },
            nova: {
                red: nova_red_png_1.default,
                color: nova_color_png_1.default,
            },
        };
        this.title = document.querySelector('.charactersHeaderText');
        this.reclaimerBtn = document.querySelector('.hero__reclaimers');
        this.novaBtn = document.querySelector('.hero__nova');
        this.neunBtn = document.querySelector('.hero__neun');
        this.previousWidth = window.innerWidth;
        this.init();
    }
    init() {
        this.updateText();
        this.setupImageHoverHandlers();
        this.preloadImages();
        // this.setupParallaxEffect();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = homeWorld[language] || homeWorld['en'];
        if (this.title)
            this.title.textContent = content.title.toUpperCase();
        if (this.reclaimerBtn)
            this.reclaimerBtn.textContent = content.reclaimer.toUpperCase();
        if (this.novaBtn)
            this.novaBtn.innerHTML = content.nova.toUpperCase();
        if (this.neunBtn)
            this.neunBtn.innerHTML = content.neun;
    }
    setupImageHoverHandlers() {
        const links = document.querySelectorAll('.charactersHome__btnlist a[data-group]');
        links.forEach(link => {
            const group = link.getAttribute('data-group');
            const img = document.getElementById(`img__${group}`);
            if (!group || !img || !this.imageMap[group])
                return;
            const handleEnter = () => this.fadeImageTransition(img, this.imageMap[group].color);
            const handleLeave = () => this.fadeImageTransition(img, this.imageMap[group].red);
            link.addEventListener('mouseenter', handleEnter);
            link.addEventListener('mouseleave', handleLeave);
            img.addEventListener('mouseenter', handleEnter);
            img.addEventListener('mouseleave', handleLeave);
        });
    }
    fadeImageTransition(img, newSrc) {
        img.classList.add('fading-out');
        setTimeout(() => {
            img.src = newSrc;
            img.classList.remove('fading-out');
        }, 150);
    }
    setupParallaxEffect() {
        document.addEventListener('scroll', () => {
            const currentWidth = window.innerWidth;
            if (currentWidth > 900) {
                this.applyParallax();
            }
            else {
                this.resetParallax();
                // Trigger a slight scroll when transitioning to <900px
                if (this.previousWidth > 900) {
                    window.scrollBy(0, 1);
                }
            }
            this.previousWidth = currentWidth;
        });
    }
    applyParallax() {
        const section = document.querySelector('.charactersHome');
        const parallaxElement = document.querySelector('.charactersHome__bg');
        if (section && parallaxElement) {
            const sectionTop = section.getBoundingClientRect().top;
            const sectionHeight = section.offsetHeight;
            const speed = 0.1;
            if (sectionTop < window.innerHeight && sectionTop > -sectionHeight) {
                let offset = sectionTop * speed - 200;
                parallaxElement.style.transform = `translateY(${offset}px)`;
            }
        }
    }
    preloadImages() {
        Object.values(this.imageMap).forEach(variant => {
            ['red', 'color'].forEach(key => {
                const img = new Image();
                img.src = variant[key];
            });
        });
    }
    resetParallax() {
        const parallaxElement = document.querySelector('.charactersHome__bg');
        if (parallaxElement) {
            parallaxElement.style.transform = 'translateY(0px)';
        }
    }
}
exports.homeCharacterContent = homeCharacterContent;
